export const ballMotion = {
	startone: {
		x: [
			Math.floor(Math.random() * 100) + 1,
			Math.floor(Math.random() * 100) + 1,
			Math.floor(Math.random() * 100) + 1,
			Math.floor(Math.random() * 100) + 1,
		],
		y: [
			Math.floor(Math.random() * 100) + 1,
			Math.floor(Math.random() * 100) + 1,
			Math.floor(Math.random() * 100) + 1,
			Math.floor(Math.random() * 100) + 1,
		],
		transition: {
			ease: "linear",
			duration: 10,
			repeat: Infinity,
			repeatType: "reverse",
		},
	},
	starttwo: {
		x: [
			Math.floor(Math.random() * 100) + 1,
			Math.floor(Math.random() * 100) + 1,
			Math.floor(Math.random() * 100) + 1,
			Math.floor(Math.random() * 100) + 1,
		],
		y: [
			Math.floor(Math.random() * 100) + 1,
			Math.floor(Math.random() * 100) + 1,
			Math.floor(Math.random() * 100) + 1,
			Math.floor(Math.random() * 100) + 1,
		],
		transition: {
			ease: "linear",
			duration: 10,
			repeat: Infinity,
			repeatType: "reverse",
		},
	},
	startthree: {
		x: [
			Math.floor(Math.random() * 100) + 1,
			Math.floor(Math.random() * 100) + 1,
			Math.floor(Math.random() * 100) + 1,
			Math.floor(Math.random() * 100) + 1,
		],
		y: [
			Math.floor(Math.random() * 100) + 1,
			Math.floor(Math.random() * 100) + 1,
			Math.floor(Math.random() * 100) + 1,
			Math.floor(Math.random() * 100) + 1,
		],
		transition: {
			ease: "linear",
			duration: 10,
			repeat: Infinity,
			repeatType: "reverse",
		},
	},
	startfour: {
		x: [
			Math.floor(Math.random() * 100) + 1,
			Math.floor(Math.random() * 100) + 1,
			Math.floor(Math.random() * 100) + 1,
			Math.floor(Math.random() * 100) + 1,
		],
		y: [
			Math.floor(Math.random() * 100) + 1,
			Math.floor(Math.random() * 100) + 1,
			Math.floor(Math.random() * 100) + 1,
			Math.floor(Math.random() * 100) + 1,
		],
		transition: {
			ease: "linear",
			duration: 10,
			repeat: Infinity,
			repeatType: "reverse",
		},
	},
	startfive: {
		x: [
			Math.floor(Math.random() * 100) + 1,
			Math.floor(Math.random() * 100) + 1,
			Math.floor(Math.random() * 100) + 1,
			Math.floor(Math.random() * 100) + 1,
		],
		y: [
			Math.floor(Math.random() * 100) + 1,
			Math.floor(Math.random() * 100) + 1,
			Math.floor(Math.random() * 100) + 1,
			Math.floor(Math.random() * 100) + 1,
		],
		transition: {
			ease: "linear",
			duration: 10,
			repeat: Infinity,
			repeatType: "reverse",
		},
	},
	startsix: {
		x: [
			Math.floor(Math.random() * 100) + 1,
			Math.floor(Math.random() * 100) + 1,
			Math.floor(Math.random() * 100) + 1,
			Math.floor(Math.random() * 100) + 1,
		],
		y: [
			Math.floor(Math.random() * 100) + 1,
			Math.floor(Math.random() * 100) + 1,
			Math.floor(Math.random() * 100) + 1,
			Math.floor(Math.random() * 100) + 1,
		],
		transition: {
			ease: "linear",
			duration: 10,
			repeat: Infinity,
			repeatType: "reverse",
		},
	},
};

export const tagMotion = {
	initial: {
		opacity: 0,
		scale: 0,
	},
	startOne: {
		opacity: 1,
		scale: 1,
		transition: {
			type: "spring",
			duration: 0.5,
		},
	},
	startTwo: {
		opacity: 1,
		scale: 1,
		transition: {
			type: "spring",
			duration: 0.5,
			delay: 0.1,
		},
	},
	startThree: {
		opacity: 1,
		scale: 1,
		transition: {
			type: "spring",
			duration: 0.5,
			delay: 0.2,
		},
	},
	startFour: {
		opacity: 1,
		scale: 1,
		transition: {
			type: "spring",
			duration: 0.5,
			delay: 0.3,
		},
	},
	startFive: {
		opacity: 1,
		scale: 1,
		transition: {
			type: "spring",
			duration: 0.5,
			delay: 0.4,
		},
	},
	startSix: {
		opacity: 1,
		scale: 1,
		transition: {
			type: "spring",
			duration: 0.5,
			delay: 0.5,
		},
	},
	startSeven: {
		opacity: 1,
		scale: 1,
		transition: {
			type: "spring",
			duration: 0.5,
			delay: 0.6,
		},
	},
	startEight: {
		opacity: 1,
		scale: 1,
		transition: {
			type: "spring",
			duration: 0.5,
			delay: 0.7,
		},
	},
	startNine: {
		opacity: 1,
		scale: 1,
		transition: {
			type: "spring",
			duration: 0.5,
			delay: 0.8,
		},
	},
	startTen: {
		opacity: 1,
		scale: 1,
		transition: {
			type: "spring",
			duration: 0.5,
			delay: 0.9,
		},
	},
};

export const dotMotion = {
	type: "spring",
	stiffness: 500,
	damping: 60,
};
